import DesignServicesIcon from '@mui/icons-material/DesignServices';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsSystemDaydreamIcon from '@mui/icons-material/SettingsSystemDaydream';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AddTaskIcon from '@mui/icons-material/AddTask';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import ReceiptIcon from '@mui/icons-material/Receipt';
import BadgeIcon from '@mui/icons-material/Badge';

import {
    DashboardActiveIcon,
    DashboardIcon,
    IssuesActiveIcon,
    IssuesIcon,
    LocationActiveIcon,
    LocationIcon,
    ProductActiveIcon,
    ProductIcon,
    ResellerActiveIcon,
    ResellerIcon,
    UsersActiveIcon,
    UsersIcon,
} from '@assets/index';

import type { RouteSegment } from '@/types/routes';
import { Today } from '@mui/icons-material';

export enum AppRoutes {
    Insights = '/insights',
    Locations = '/locations',
    Products = '/products',
    TodaysCuts = '/todays-cuts',
    Issues = '/issues',
    Resellers = '/resellers',
    ResellersSecondary = '/resellers/2',
    Users = '/users',
    ManageUser = '/users/user',
    Login = '/login',
    ResetPassword = '/reset',
    Models = '/models',
    Design = '/design',
    Manufacturers = '/manufacturers',
    Coverages = '/coverages',
    SystemManagement = '/manage/systems',
    ManageCompany = '/manage/systems/company',
    ManageReseller = '/manage/systems/reseller',
    ManageLocation = '/manage/systems/location',
    ManageSystem = '/manage/systems/system',
    Organizations = '/manage/organizations',
    Activity = '/activity',
    CutHistory = '/activity/history',
    ExportActivity = '/activity/export',
    BatchProcessing = '/batches',
    Invoices = '/invoices',
    Employees = '/employees',
    Tickets = '/tickets',
    TicketForm = '/tickets/form',
    TroubleShooter = '/tickets/troubleshooter',
    EmployeeDetails = '/employees/employee',
}

export const REPORT_ROUTES: RouteSegment = {
    name: 'reports',
    Icon: <InsertDriveFileIcon fontSize={'small'} />,
    IconActive: <InsertDriveFileIcon fontSize={'small'} color={'primary'} />,
    routes: [
        {
            link: AppRoutes.Insights,
            label: 'dashboard',
            Icon: <DashboardIcon />,
            IconActive: <DashboardActiveIcon />,
        },
        {
            link: AppRoutes.Resellers,
            extraActive: [AppRoutes.ResellersSecondary],
            label: 'resellers',
            Icon: <ResellerIcon />,
            IconActive: <ResellerActiveIcon />,
        },
        {
            link: AppRoutes.Locations,
            label: 'locations',
            Icon: <LocationIcon />,
            IconActive: <LocationActiveIcon />,
        },
        {
            link: AppRoutes.Products,
            label: 'products',
            Icon: <ProductIcon />,
            IconActive: <ProductActiveIcon />,
        },
        {
            link: AppRoutes.Issues,
            label: 'issues',
            Icon: <IssuesIcon />,
            IconActive: <IssuesActiveIcon />,
        },
        {
            link: AppRoutes.TodaysCuts,
            label: "today's cuts",
            Icon: <Today sx={{ width: '18px', height: '18px' }} />,
            IconActive: <Today sx={{ width: '18px', height: '18px' }} color={'primary'} />,
        },
        {
            link: AppRoutes.Employees,
            label: 'Employee Reports',
            Icon: <BadgeIcon sx={{ width: '18px', height: '18px' }} />,
            IconActive: <BadgeIcon sx={{ width: '18px', height: '18px' }} color={'primary'} />,
            extraActive: [AppRoutes.EmployeeDetails],
        },
    ],
};

export const ACTIVITY_ROUTES: RouteSegment = {
    name: 'activity',
    Icon: <AssessmentIcon fontSize={'small'} />,
    IconActive: <AssessmentIcon fontSize={'small'} color={'primary'} />,
    routes: [
        {
            link: AppRoutes.Activity,
            label: 'activity',
            Icon: <AssessmentIcon fontSize={'small'} />,
            IconActive: <AssessmentIcon fontSize={'small'} color={'primary'} />,
        },
    ],
};

export const MANAGE_ROUTES: RouteSegment = {
    name: 'manage',
    Icon: <SettingsIcon fontSize={'small'} />,
    IconActive: <SettingsIcon fontSize={'small'} color={'primary'} />,
    routes: [
        {
            link: AppRoutes.Models,
            label: 'designs',
            Icon: <DesignServicesIcon fontSize={'small'} />,
            IconActive: <DesignServicesIcon fontSize={'small'} color={'primary'} />,
            extraActive: [AppRoutes.Coverages, AppRoutes.Design, AppRoutes.Manufacturers],
        },
        {
            link: AppRoutes.Users,
            label: 'users',
            Icon: <UsersIcon />,
            IconActive: <UsersActiveIcon />,
        },
        {
            link: AppRoutes.Organizations,
            label: 'organizations',
            Icon: <CorporateFareIcon />,
            IconActive: <CorporateFareIcon color={'primary'} />,
        },
        {
            link: AppRoutes.SystemManagement,
            label: 'Rapidcut Systems',
            Icon: <SettingsSystemDaydreamIcon />,
            IconActive: <SettingsSystemDaydreamIcon color={'primary'} />,
            extraActive: [
                AppRoutes.ManageCompany,
                AppRoutes.ManageLocation,
                AppRoutes.ManageReseller,
                AppRoutes.ManageSystem,
            ],
        },
        {
            link: AppRoutes.BatchProcessing,
            label: 'Batch Approval',
            Icon: <AddTaskIcon fontSize='small' />,
            IconActive: <AddTaskIcon fontSize='small' color={'primary'} />,
        },
        {
            link: AppRoutes.Invoices,
            label: 'Invoices',
            Icon: <ReceiptIcon fontSize='small' />,
            IconActive: <ReceiptIcon fontSize='small' color={'primary'} />,
        },
    ],
};

export const ROUTES = [REPORT_ROUTES, ACTIVITY_ROUTES, MANAGE_ROUTES];
